import actions from "../../constants/actions";

export const loadBlog = (refresh = false, tag = null) => {
    if (tag) {
        return {
            type: actions.BLOG.LOAD_LIST,
            payload: {
                refresh,
                options: {
                    "filter[tag]": tag,
                },
            },
        };
    }

    return {
        type: actions.BLOG.LOAD_LIST,
        payload: {
            refresh,
            options: {},
        },
    };
};

export const loadArticle = (slug) => {
    return {
        type: actions.BLOG.LOAD,
        payload: {
            slug,
            options: {},
        },
    };
};

export const loadRelatedArticles = (slug) => {
    return {
        type: actions.BLOG.LOAD_RELATED,
        payload: {
            slug,
            options: {},
        },
    };
};

export const loadTags = () => {
    return {
        type: actions.BLOG.LOAD_TAGS,
        payload: {
            options: {},
        },
    };
};
